var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',[[_c('StockInvoiceStakeholderDocuments',{attrs:{"stockDocData":_vm.pallet.stockDocData,"stakeHolderName":_vm.$t('PALLET'),"source":'pallet',"invoiceId":_vm.invoiceId,"isPreviewMode":_vm.isPreviewMode},on:{"reloadInvoiceData":_vm.reloadInvoiceData}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }